export default __webpack_public_path__ + "static/media/north-america-countries.63a1b340.jpeg";